(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-advertorial-good"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var wrap = root.querySelector('.hgag');
    if (!wrap || wrap.dataset.hgagReady === '1') return;
    wrap.dataset.hgagReady = '1';

    if (wrap.dataset.hideChrome === 'true') document.body.classList.add('hgag-chrome-off');

    // FAQ accordion + "see more"
    wrap.querySelectorAll('.hgag-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.hgag-faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    wrap.querySelectorAll('.hgag-faq__more').forEach(function (more) {
      more.addEventListener('click', function () {
        var scope = more.closest('.hgag-faq');
        scope.querySelectorAll('.hgag-faq__item--hidden').forEach(function (el) {
          el.classList.remove('hgag-faq__item--hidden');
        });
        more.style.display = 'none';
      });
    });

    // Optional MM:SS countdown in the announcement bar (0 = off, matching source)
    var mins = parseInt(wrap.dataset.countdown, 10);
    var timerEl = wrap.querySelector('[data-hgag-timer]');
    if (timerEl && mins > 0) {
      var left = mins * 60;
      timerEl.classList.add('is-on');
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        if (left <= 0) { timerEl.classList.remove('is-on'); return; }
        left -= 1;
        timerEl.textContent = pad(Math.floor(left / 60)) + ' : ' + pad(left % 60);
      };
      tick();
      setInterval(tick, 1000);
    }

    // Placeholder links resolve to the offer page.
    wrap.addEventListener('click', function (evt) {
      var link = evt.target.closest('a');
      if (!link || !wrap.contains(link)) return;
      if (link.getAttribute('href') !== '#') return;
      evt.preventDefault();
      window.location.href = wrap.dataset.offerUrl || '/';
    });
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-advertorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var wrap = root.querySelector('.hgadv');
    if (!wrap || wrap.dataset.hgadvReady === '1') return;
    wrap.dataset.hgadvReady = '1';

    // Localised publication date, matching the skeleton's runtime date stamp.
    // Stamps read DD/MM/YYYY à HH:MM, matching the reference layout.
    // Published is pinned to 09:00 so it stays stable through the day;
    // the updated stamp tracks the current time so the page never reads stale.
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var now = new Date();
    var day = pad(now.getDate()) + '/' + pad(now.getMonth() + 1) + '/' + now.getFullYear();
    var dateEl = wrap.querySelector('[data-adv-date]');
    if (dateEl) { dateEl.textContent = day + ' \u00e0 09:00'; }
    var updEl = wrap.querySelector('[data-adv-updated]');
    if (updEl) { updEl.textContent = day + ' \u00e0 ' + pad(now.getHours()) + ':' + pad(now.getMinutes()); }

    // One delegated handler replaces the skeleton's inline onclick="sendPb()".
    var offerUrl = wrap.dataset.offerUrl || '/';
    wrap.addEventListener('click', function (evt) {
      var link = evt.target.closest('a');
      if (!link || !wrap.contains(link)) return;
      var href = link.getAttribute('href');
      if (href && href !== '#') return; // real links (incl. rich-text) pass through
      evt.preventDefault();
      window.location.href = offerUrl;
    });

    if (wrap.dataset.hideChrome === 'true') {
      document.body.classList.add('hgadv-chrome-off');
    }
  }

  function boot() { init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  class HgCartDrawer extends HTMLElement {
    #controller = null;
    #lifetime = null;
    #wiping = null;
    #cart = null;
    #refreshing = null;
    #refreshPending = false;
    #internalAddCount = 0;
    #lineBusy = new Set();
    _compareAtMap = {};
    _sellingPlanByVariant = {};
    _subPriceMap = {};

    connectedCallback() {
      this.dialog = this.querySelector('dialog.hg-cart');
      this.itemsEl = this.querySelector('[data-hg-items]');
      this.emptyEl = this.querySelector('[data-hg-empty]');
      this.countEl = this.querySelector('[data-hg-count]');
      this.countWrapEl = this.querySelector('[data-hg-count-wrap]');
      this.totalEl = this.querySelector('[data-hg-total]');
      this.compareEl = this.querySelector('[data-hg-compare]');
      this.savingsEl = this.querySelector('[data-hg-savings]');
      this.shipMsg = this.querySelector('[data-hg-ship-msg]');
      this.shipBar = this.querySelector('[data-hg-ship-bar]');
      this.protectionEl = this.querySelector('[data-hg-protection]');
      this.protectionToggle = this.querySelector('[data-hg-protection-toggle]');
      this.upsellEl = this.querySelector('[data-hg-upsell]');
      this.upsellAdd = this.querySelector('[data-hg-upsell-add]');
      this.subUpgradeEl = this.querySelector('[data-hg-sub-upgrade]');
      this.subUpgradeBtn = this.querySelector('[data-hg-sub-upgrade-btn]');
      this.subUpgradeLabel = this.querySelector('[data-hg-sub-upgrade-label]');
      this.errorEl = this.querySelector('[data-hg-error]');

      this.config = {
        moneyFormat: this.getAttribute('data-money-format') || (('{' + '{amount_with_comma_separator' + '}' + '}') + ' €'),
        cartAddUrl: this.dataset.cartAddUrl || '/cart/add',
        cartChangeUrl: this.dataset.cartChangeUrl || '/cart/change',
        cartUrl: this.dataset.cartUrl || '/cart',
        freeShipThresholdCents: parseInt(this.dataset.freeShipThresholdCents, 10) || 5000,
        freeShipMsgUnder: this.dataset.freeShipMsgUnder || 'Plus que REMAINING_AMOUNT pour la <strong>livraison offerte</strong>',
        freeShipMsgOver: this.dataset.freeShipMsgOver || 'Félicitations, vous avez débloqué la <strong>LIVRAISON OFFERTE&nbsp;!</strong>',
        protectionVariantId: this.dataset.protectionVariantId ? parseInt(this.dataset.protectionVariantId, 10) : null,
        protectionPrice: parseInt(this.dataset.protectionPrice, 10) || 0,
        protectionTitle: this.dataset.protectionTitle || 'Protection Livraison',
        protectionDesc: this.dataset.protectionDesc || '',
        upsellVariantId: this.dataset.upsellVariantId ? parseInt(this.dataset.upsellVariantId, 10) : null,
        upsellImage: this.dataset.upsellImage || '',
        upsellTitle: this.dataset.upsellTitle || '',
        upsellDesc: this.dataset.upsellDesc || '',
        upsellPrice: this.dataset.upsellPrice || '',
        upsellCompareAt: this.dataset.upsellCompareAt || '',
        upsellPitch: this.dataset.upsellPitch || '',
        upsellBody: this.dataset.upsellBody || '',
        upsellDisclaimer: this.dataset.upsellDisclaimer || '',
        upsellCta: this.dataset.upsellCta || 'Ajouter au panier',
        savingsLabel: this.dataset.savingsLabel || 'économisés',
        trust1: this.getAttribute('data-trust-1') || '<strong>4,7 / 5</strong>112&nbsp;000+ avis',
        trust2: this.getAttribute('data-trust-2') || '<strong>Sans engagement</strong>Pause ou résil.',
        trust3: this.getAttribute('data-trust-3') || '<strong>60 jours</strong>Satisfait / remb.',
        errProtection: this.dataset.errProtection || '',
        errQty: this.dataset.errQty || '',
        errUpsell: this.dataset.errUpsell || '',
        errSubscription: this.dataset.errSubscription || '',
        errGeneric: this.dataset.errGeneric || '',
        protectionPref: this.#readProtectionPref(),
      };

      // Critical wiring — must run sync so taps that fire right after first paint are caught.
      this.#lifetime = new AbortController();
      const life = this.#lifetime.signal;
      this.#attachListeners(life);
      this.#bindGlobalCartTriggers(life);
      this.#interceptCartFetch();
      this.#interceptCartForms();
      this.#interceptCartXHR();

      // Render static (upsell/protection placeholders) on next frame, then fetch cart in background.
      requestAnimationFrame(() => {
        this.#renderStatic();
        this.refresh();
      });

      // bfcache restore (back button on iOS Safari + Samsung Internet) — re-sync cart state.
      window.addEventListener('pageshow', (e) => {
        if (e.persisted) this.refresh();
      }, { signal: life });

      try {
        const params = new URLSearchParams(window.location.search);
        if (params.get('cart') === 'open') {
          requestAnimationFrame(() => this.open());
        }
      } catch (_) { /* defensive: URLSearchParams in older browsers */ }
    }

    disconnectedCallback() {
      this.#lifetime?.abort();
      this.#controller?.abort();
    }

    #readProtectionPref() {
      try { return localStorage.getItem('hg-protection') !== 'off'; }
      catch (_) { return true; }
    }

    open = async () => {
      try {
        if (this.#wiping) await this.#wiping;
        if (!this.dialog) return;
        this.dialog.classList.add('hg-cart--loading');

        if (!this.dialog.open && !this.dialog.classList.contains('hg-cart--fallback')) {
          this.#lockBodyScroll();
          let shown = false;

          // Same path on iOS and Android Instagram: native dialog, then the IAB CSS
          // pins it to the webview (no slide, no gray overlay). Fallback is last resort only.
          if (typeof this.dialog.showModal === 'function') {
            try {
              this.dialog.showModal();
              shown = !!this.dialog.open;
            } catch (e) {
              console.warn('hg-cart showModal failed:', e);
            }
          }

          if (!shown && typeof this.dialog.show === 'function') {
            try {
              this.dialog.show();
              shown = !!this.dialog.open;
            } catch (e) {
              console.warn('hg-cart show() failed:', e);
            }
          }

          if (!shown) {
            this.dialog.setAttribute('open', '');
            this.dialog.classList.add('hg-cart--fallback');
          }
        }

        await this.refresh();
      } catch (error) {
        console.error('hg-cart open error:', error);
      } finally {
        if (this.dialog) this.dialog.classList.remove('hg-cart--loading');
      }
    };

    // Called by the buybox before every add. Returns true only when the cart is
    // confirmed empty, so the next pack replaces the previous one.
    // /cart/clear.js hangs in the Facebook and Instagram browser, which is why
    // those browsers used to skip this and append. Zeroing each line through
    // /cart/update.js does the same job without that request.
    async prepareFreshAdd() {
      if (this.#wiping) await this.#wiping;
      if (this.#refreshing) await this.#refreshing;
      const inApp = document.documentElement.hasAttribute('data-hg-iab');
      if (inApp) return this.#emptyCartLines();
      try {
        const r = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        });
        this.#cart = r.ok ? await r.json() : await this.#fetchCart();
      } catch (_) {
        try { this.#cart = await this.#fetchCart(); } catch (_) { /* offline */ }
      }
      if (this.itemsEl) this.itemsEl.innerHTML = '';
      this.#emitCartEvents(this.#cart);
      return !(this.#cart?.items || []).length;
    }

    async #emptyCartLines() {
      let cart = null;
      try {
        const r = await fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (r.ok) cart = await r.json();
      } catch (_) {}
      if (!cart) return false;
      this.#cart = cart;
      if (!(cart.items || []).length) return true;
      const updates = {};
      cart.items.forEach((it) => { if (it.key) updates[it.key] = 0; });
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 1200);
      try {
        const r = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        this.#cart = r.ok ? await r.json() : null;
      } catch (_) {
        this.#cart = null;
      } finally {
        clearTimeout(timer);
      }
      const empty = !!this.#cart && !(this.#cart.items || []).length;
      if (empty) {
        if (this.itemsEl) this.itemsEl.innerHTML = '';
        this.#emitCartEvents(this.#cart);
      }
      return empty;
    }

    close = () => {
      try {
        if (this.dialog) {
          if (this.dialog.open) this.dialog.close();
          // Clean up fallback open state if showModal wasn't supported.
          this.dialog.removeAttribute('open');
          this.dialog.classList.remove('hg-cart--fallback');
        }
        this.#unlockBodyScroll();
        // Instagram / Facebook WebViews often hang or drop /cart/clear.js, which
        // looks like "opened with nothing" after a successful add. Leave the cart
        // in place there. Elsewhere, wipe on dismiss so the next add starts clean.
        if (document.documentElement.hasAttribute('data-hg-iab')) return;
        this.#wiping = this.#wipeCartOnClose().finally(() => { this.#wiping = null; });
      } catch (error) {
        console.error('hg-cart close error:', error);
      }
    };

    #wipeCartOnClose = async () => {
      // Nothing to wipe if the cart is already empty.
      if (this.#cart && Array.isArray(this.#cart.items) && this.#cart.items.length === 0) return;
      try {
        const r = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        });
        this.#cart = r.ok ? await r.json() : await this.#fetchCart();
      } catch (_) {
        try { this.#cart = await this.#fetchCart(); } catch (_) { /* offline — leave as-is */ }
      }
      // Clear the rendered list and broadcast so the header cart-count bubble
      // (and any other listener) drops to zero immediately.
      if (this.itemsEl) this.itemsEl.innerHTML = '';
      this.#emitCartEvents(this.#cart);
    };

    #lockBodyScroll() {
      if (this._scrollLocked) return;
      this._scrollLocked = true;
      this._scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this._scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    #unlockBodyScroll() {
      if (!this._scrollLocked) return;
      this._scrollLocked = false;
      const y = this._scrollY || 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      window.scrollTo(0, y);
    }

    async refresh(prefetchedCart) {
      // Coalesce concurrent refreshes into a single in-flight run — but if another
      // refresh is requested WHILE one is running, loop once more with fresh cart
      // data before resolving. Without this, a refresh triggered mid-flight (e.g. an
      // add fired while the drawer's own hydrate / protection sync from opening is
      // still running) would be handed the older promise, which already fetched the
      // PRE-mutation cart. The render then shows stale data — e.g. "Économise 0,00 €"
      // while a one-time pot is in the cart — until the next unrelated refresh.
      if (this.#refreshing) {
        this.#refreshPending = true;
        return this.#refreshing;
      }
      this.#refreshing = (async () => {
        try {
          do {
            this.#refreshPending = false;
            const cart = prefetchedCart || await this.#fetchCart();
            prefetchedCart = null; // a prefetched cart is only valid for the first pass
            if (cart) this.#cart = cart;
            if (window.__hgReconcileFreeGift) {
              try {
                const guarded = await window.__hgReconcileFreeGift();
                if (guarded) this.#cart = guarded;
              } catch (e) { console.error('hg-cart free-gift guard error:', e); }
            }
            // Order matters: kill a free-only cart BEFORE syncing gifts/protection, so
            // we never re-add pots to a cart the guard just wiped.
            try {
              const wiped = await this.#enforceAnchorIntegrity();
              if (!wiped) {
                await this.#syncFreeGift();
                await this.#syncSubscriptionPlan();
              }
            } catch (e) { console.error('hg-cart free-gift sync error:', e); }
            try { await this.#syncProtection(); } catch (e) { console.error('hg-cart protection sync error:', e); }
            try { await this.#hydrateCompareAt(this.#cart); } catch (e) { console.error('hg-cart compare-at hydration error:', e); }
            this.#render();
            if (this.#cart) this.#emitCartEvents(this.#cart);
            // If a refresh was requested mid-run, the syncs above are idempotent, so
            // looping again just re-fetches and re-renders with the latest cart.
          } while (this.#refreshPending);
        } catch (error) {
          console.error('hg-cart refresh error:', error);
        } finally {
          this.#refreshing = null;
        }
      })();
      return this.#refreshing;
    }

    async #hydrateCompareAt(cart) {
      if (!cart?.items?.length) return;
      const handles = [];
      cart.items.forEach((it) => {
        if (!it.handle) return;
        if (this._compareAtMap[it.variant_id] !== undefined) return;
        if (!handles.includes(it.handle)) handles.push(it.handle);
      });
      if (!handles.length) return;
      await Promise.all(handles.map(async (h) => {
        try {
          const r = await fetch(`/products/${h}.js`, { headers: { Accept: 'application/json' } });
          if (!r.ok) return;
          const p = await r.json();
          (p.variants || []).forEach((v) => {
            this._compareAtMap[v.id] = v.compare_at_price || 0;
            // Cache the actual Kaching/Shopify subscription price for the
            // first selling-plan allocation on this variant. We use this in
            // #renderImpl to compute the precise "Save €X" amount instead of
            // a hardcoded 25% guess. If the variant has no selling plans the
            // map entry stays unset → the line contributes 0 to savings.
            const subPrice = v.selling_plan_allocations?.[0]?.price;
            if (typeof subPrice === 'number') {
              this._subPriceMap[v.id] = subPrice;
            }
          });
        } catch (_) { /* network */ }
      }));
    }

    #setText(selector, value) {
      const el = this.querySelector(selector);
      if (el) el.textContent = value || '';
    }

    #setHTML(selector, value) {
      const el = this.querySelector(selector);
      if (el) el.innerHTML = value || '';
    }

    #renderStatic() {
      if (this.config.protectionVariantId) {
        this.#setText('[data-hg-protection-title]', this.config.protectionTitle);
        this.#setText('[data-hg-protection-desc]', this.config.protectionDesc);
        this.#setText('[data-hg-protection-price]', this.#formatMoney(this.config.protectionPrice));
      }

      if (this.config.upsellVariantId) {
        // Schema setting is `richtext` which produces `<p>...</p>` wrapped content.
        // The targets are an <h3> (pitch) and a <p> (body). Strip the outer <p> so
        // we don't end up with <h3><p>...</p></h3> or <p><p>...</p></p> (invalid + collapses layout).
        const stripOuterP = (html) => String(html || '').replace(/^\s*<p[^>]*>([\s\S]*)<\/p>\s*$/i, '$1');
        this.#setHTML('[data-hg-upsell-pitch]', stripOuterP(this.config.upsellPitch));
        this.#setHTML('[data-hg-upsell-body]', stripOuterP(this.config.upsellBody));
        this.#setText('[data-hg-upsell-disclaimer]', this.config.upsellDisclaimer);

        const upsellTitle = this.#brandify(this.config.upsellTitle);
        const imgEl = this.querySelector('[data-hg-upsell-image]');
        if (imgEl) {
          imgEl.src = this.config.upsellImage;
          imgEl.alt = upsellTitle;
        }
        this.#setText('[data-hg-upsell-title]', upsellTitle);
        this.#setText('[data-hg-upsell-price]', this.config.upsellPrice);
        this.#setText('[data-hg-upsell-cta-label]', this.config.upsellCta);
        const compare = this.querySelector('[data-hg-upsell-compare]');
        if (compare && this.config.upsellCompareAt) {
          compare.textContent = this.config.upsellCompareAt;
          compare.hidden = false;
        }
      }

      ['trust-1', 'trust-2', 'trust-3'].forEach((sel, idx) => {
        const el = this.querySelector(`[data-hg-${sel}]`);
        if (el) el.innerHTML = this.config[`trust${idx + 1}`];
      });
    }

    #attachListeners(lifeSignal) {
      this.querySelectorAll('[data-hg-close]').forEach((el) => {
        el.addEventListener('click', this.close);
      });

      this.dialog.addEventListener('click', (e) => {
        if (e.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        const inside = e.clientX >= rect.left && e.clientX <= rect.right
                    && e.clientY >= rect.top  && e.clientY <= rect.bottom;
        if (!inside) this.close();
      });

      this.dialog.addEventListener('close', () => this.#unlockBodyScroll());
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });

      if (this.protectionToggle) {
        this.protectionToggle.addEventListener('click', this.#handleProtectionToggle);
      }
      if (this.upsellAdd) {
        this.upsellAdd.addEventListener('click', this.#handleUpsellAdd);
      }
      if (this.subUpgradeBtn) {
        this.subUpgradeBtn.addEventListener('click', this.#handleSubUpgrade);
      }

      document.addEventListener('hg-cart:open', this.open, { signal: lifeSignal });
      document.addEventListener('hg-cart:refresh', () => this.refresh(), { signal: lifeSignal });
      // Legacy alias — product-form.js and older snippets used wg-cart:* before hg-cart.
      document.addEventListener('wg-cart:open', this.open, { signal: lifeSignal });
      document.addEventListener('wg-cart:refresh', () => this.refresh(), { signal: lifeSignal });

      // Listen for standard Shopify cart events so we re-render whenever ANY
      // code path mutates the cart (Kaching app blocks, upsell apps, theme
      // section forms, etc. — not just our own buttons). Without this the
      // drawer stays on stale data and the savings calc shows the wrong amount.
      // Two guards prevent loops:
      //   - _emittingCartEvents: skip our own emits (see #emitCartEvents).
      //   - #internalAddCount: skip when our own #addVariant is mid-flight and
      //     will trigger a refresh itself anyway.
      const externalRefresh = () => {
        if (this._emittingCartEvents) return;
        if (this.#internalAddCount > 0) return;
        this.refresh();
      };
      document.addEventListener('cart:updated', externalRefresh, { signal: lifeSignal });
      document.addEventListener('cart:refresh', externalRefresh, { signal: lifeSignal });
    }

    #bindGlobalCartTriggers(lifeSignal) {
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest?.('[data-hg-cart-trigger], [data-wg-cart-trigger]');
        if (trigger) {
          e.preventDefault();
          e.stopPropagation();
          this.open();
          return;
        }
        const cartLink = e.target.closest?.('a[href$="/cart"], a[href="/cart"]');
        if (cartLink && !cartLink.closest('hg-cart-drawer')) {
          const href = cartLink.getAttribute('href');
          if (href && !href.includes('/cart/')) {
            e.preventDefault();
            e.stopPropagation();
            this.open();
          }
        }
      }, { capture: true, signal: lifeSignal });
    }

    #interceptCartFetch() {
      if (window.__hgCartFetchPatched) {
        window.__hgCartDrawerInstance = this;
        return;
      }
      window.__hgCartFetchPatched = true;
      window.__hgCartDrawerInstance = this;
      const original = window.fetch;
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : (input?.url ?? '');
        const instance = window.__hgCartDrawerInstance;
        const isAdd = url.includes('/cart/add');
        const isInternal = instance ? instance._internalAdding() : false;
        let isWgSource = false;
        try {
          const headers = init && init.headers;
          if (headers) {
            if (typeof headers.get === 'function') {
              isWgSource = !!headers.get('X-WG-Source');
            } else if (Array.isArray(headers)) {
              isWgSource = headers.some(([k]) => String(k).toLowerCase() === 'x-wg-source');
            } else {
              isWgSource = Object.keys(headers).some((k) => k.toLowerCase() === 'x-wg-source');
            }
          }
          if (!isWgSource && input && typeof input !== 'string' && input.headers && typeof input.headers.get === 'function') {
            isWgSource = !!input.headers.get('X-WG-Source');
          }
        } catch (_) { /* defensive */ }

        const result = original.apply(this, arguments);
        if (isAdd && !isInternal && !isWgSource && instance) {
          result.then((res) => {
            if (res && res.ok) queueMicrotask(() => instance.open());
          }).catch(() => {});
        }
        return result;
      };
    }

    // Catches any classic <form action="/cart/add"> POST and converts it to a fetch + drawer open.
    // Runs at capture phase on the document so it preempts section-specific submit handlers
    // (which may be missing or broken on Samsung Internet / Android WebView).
    #interceptCartForms() {
      if (window.__hgCartFormsPatched) {
        window.__hgCartDrawerInstance = this;
        return;
      }
      window.__hgCartFormsPatched = true;
      const instance = this;
      document.addEventListener('submit', function (e) {
        const form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        const action = form.getAttribute('action') || form.action || '';
        if (!action.includes('/cart/add')) return;
        // Offer buybox owns its own add (split paid/gift + selling plan). Letting this
        // interceptor POST FormData would either double-add or send the wrong payload.
        if (form.hasAttribute('data-wgl-form')) return;
        // Skip if a section JS handler already prevented default (it'll do its own fetch + dispatch).
        if (e.defaultPrevented) return;

        e.preventDefault();

        const formData = new FormData(form);
        const items = {};
        const properties = {};
        formData.forEach((value, key) => {
          if (key.startsWith('properties[')) {
            const propKey = key.slice('properties['.length, -1);
            properties[propKey] = value;
          } else {
            items[key] = value;
          }
        });
        if (Object.keys(properties).length) items.properties = properties;

        instance.#internalAddCount++;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-WG-Source': 'drawer-form-intercept'
          },
          body: JSON.stringify(items)
        })
          .then(r => r.ok ? r.json() : null)
          .then(() => {
            instance.#internalAddCount--;
            instance.refresh();
            instance.open();
          })
          .catch((err) => {
            instance.#internalAddCount--;
            console.error('hg-cart form intercept error:', err);
          });
      }, true);
    }

    // XHR backup — covers any legacy code that uses XMLHttpRequest to /cart/add.
    // Most modern themes use fetch, but Samsung Internet has been known to use XHR shims.
    #interceptCartXHR() {
      if (window.__hgCartXHRPatched) return;
      window.__hgCartXHRPatched = true;
      const OriginalXHR = window.XMLHttpRequest;
      if (!OriginalXHR) return;
      const origOpen = OriginalXHR.prototype.open;
      const origSend = OriginalXHR.prototype.send;
      OriginalXHR.prototype.open = function (method, url) {
        this.__hgUrl = url;
        this.__hgMethod = method;
        return origOpen.apply(this, arguments);
      };
      OriginalXHR.prototype.send = function () {
        const xhr = this;
        const url = xhr.__hgUrl || '';
        const isAdd = typeof url === 'string' && url.includes('/cart/add');
        if (isAdd) {
          xhr.addEventListener('load', function () {
            const instance = window.__hgCartDrawerInstance;
            if (xhr.status >= 200 && xhr.status < 300 && instance && !instance._internalAdding()) {
              queueMicrotask(() => instance.open());
            }
          });
        }
        return origSend.apply(this, arguments);
      };
    }

    _internalAdding() { return this.#internalAddCount > 0; }

    async #fetchCart() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      try {
        const response = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          signal: this.#controller.signal,
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return await response.json();
      } catch (error) {
        if (error.name === 'AbortError') return this.#cart;
        console.error('hg-cart fetch error:', error);
        return null;
      }
    }

    async #changeLine(key, qty) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    }

    async #addVariant(variantId, quantity = 1) {
      this.#internalAddCount++;
      try {
        const response = await fetch(this.config.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return await response.json();
      } finally {
        this.#internalAddCount--;
      }
    }

    #nonProtectionItems(cart) {
      if (!cart?.items) return [];
      return cart.items.filter((it) => !this.config.protectionVariantId || it.variant_id !== this.config.protectionVariantId);
    }

    #protectionLine(cart) {
      if (!cart?.items || !this.config.protectionVariantId) return null;
      return cart.items.find((it) => it.variant_id === this.config.protectionVariantId) ?? null;
    }

    // ── Free-gift ladder ──────────────────────────────────────────────
    // The drawer re-derives free pots from cart state on every refresh; it never
    // trusts the buybox to have left the cart correct. The ladder (paid→free tiers)
    // and the free-pot variant id are read from the buybox DOM so they're defined
    // once, never duplicated here.

    // An "anchor" = a line the customer actually pays for (final_price > 0) that
    // isn't the protection add-on. Free pots (€0) are never anchors. NOTE: we do
    // NOT exclude the upsell variant — in this theme the subscription upsell reuses
    // the MAIN pot variant, so excluding it would drop every paid pot and the guard
    // would wipe valid carts.
    #anchorItems(cart) {
      if (!cart?.items) return [];
      return cart.items.filter((it) => {
        if (!(it.final_price > 0)) return false;
        if (this.config.protectionVariantId && it.variant_id === this.config.protectionVariantId) return false;
        return true;
      });
    }

    // Read {paid, free} tiers + the free-pot variant id off the buybox pills.
    // Returns null when no buybox is on the page (e.g. /cart) → callers no-op.
    #giftLadder() {
      const box = document.querySelector('[data-wgl-buybox][data-wgl-free-id]');
      if (!box) return null;
      const freeVariantId = parseInt(box.getAttribute('data-wgl-free-id') || '0', 10) || 0;
      if (!freeVariantId) return null;
      // The buybox's own product id. The free-pot ladder is driven by MAIN pots only —
      // a distinct paid cross-sell (e.g. the Magnésium upsell) must not count toward the
      // free-Booster tiers. 0 when absent → syncFreeGift falls back to counting all paid.
      const mainProductId = parseInt(box.getAttribute('data-wgl-main-id') || '0', 10) || 0;
      const tiers = [];
      // Both buyboxes render the quantity pills as .bundle; .q-pill is kept for any
      // older page still using that class. Reading only .q-pill left tiers empty, so
      // this returned null and the whole free-pot ladder silently no-opped in the
      // drawer: changing quantity there never added or removed a free pot.
      box.querySelectorAll('.bundle[data-wgl-qty], .q-pill[data-wgl-qty]').forEach((p) => {
        const total = parseInt(p.dataset.wglQty || '0', 10) || 0;
        const free = parseInt(p.dataset.wglFree || '0', 10) || 0;
        if (total > 0) tiers.push({ paid: total - free, free });
      });
      if (!tiers.length) return null;
      tiers.sort((a, b) => a.paid - b.paid);
      return { freeVariantId, mainProductId, tiers };
    }

    // Bundle pill index → Kaching selling plan id (mirrors buybox applyBundleFrequency).
    // Works without a free-gift product — only needs the buybox on the page.
    #bundlePlanMap() {
      const box = document.querySelector('[data-wgl-buybox]');
      if (!box) return null;
      const planIds = [...box.querySelectorAll('.freq-opt[data-wgl-plan]')]
        .map((el) => parseInt(el.dataset.wglPlan || '0', 10) || 0)
        .filter(Boolean);
      if (!planIds.length) return null;
      const tiers = [];
      box.querySelectorAll('.bundle[data-wgl-qty], .q-pill[data-wgl-qty]').forEach((pill, pillIdx) => {
        const total = parseInt(pill.dataset.wglQty || '0', 10) || 0;
        const free = parseInt(pill.dataset.wglFree || '0', 10) || 0;
        const paid = total - free;
        if (paid <= 0) return;
        tiers.push({
          paid,
          planId: planIds[Math.min(pillIdx, planIds.length - 1)],
        });
      });
      if (!tiers.length) return null;
      tiers.sort((a, b) => a.paid - b.paid);
      const mainProductId = parseInt(box.getAttribute('data-wgl-main-id') || '0', 10) || 0;
      return { mainProductId, tiers, fallbackPlanId: planIds[0] };
    }

    #planIdForPaidQty(paidQty, map) {
      let planId = map.fallbackPlanId;
      map.tiers.forEach((t) => { if (paidQty >= t.paid) planId = t.planId; });
      return planId;
    }

    // When qty changes in the drawer, re-lock the subscription cadence to the matching
    // bundle tier (1 paid → 1 mo, 2 paid → 3 mo, 3+ paid → 6 mo) — same mapping as
    // the buybox's applyBundleFrequency(pillIdx). Multiple subscribed lines for the
    // same product are merged into one line so Shopify can't split plans across rows.
    async #syncSubscriptionPlan() {
      const map = this.#bundlePlanMap();
      if (!map) return;
      const cart = this.#cart;
      if (!cart?.items?.length) return;

      const subscribedLines = this.#anchorItems(cart).filter((it) => {
        if (!it.selling_plan_allocation) return false;
        if (map.mainProductId && it.product_id !== map.mainProductId) return false;
        return true;
      });
      if (!subscribedLines.length) return;

      const totalPaidQty = subscribedLines.reduce((sum, it) => sum + it.quantity, 0);
      const targetPlanId = this.#planIdForPaidQty(totalPaidQty, map);
      if (!targetPlanId) return;

      const primary = subscribedLines[0];
      const currentPlanId = primary.selling_plan_allocation?.selling_plan?.id
        || primary.selling_plan_allocation?.selling_plan_id;
      const needsMerge = subscribedLines.length > 1;
      const needsPlanChange = targetPlanId !== currentPlanId
        || primary.quantity !== totalPaidQty;

      if (!needsMerge && !needsPlanChange) return;

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: primary.key,
          quantity: totalPaidQty,
          selling_plan: targetPlanId,
        }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      this.#cart = await response.json();

      for (let i = 1; i < subscribedLines.length; i++) {
        const extra = subscribedLines[i];
        const removed = await this.#changeLine(extra.key, 0);
        if (removed) this.#cart = removed;
      }
    }

    // The free-checkout loophole guard. If the cart has lines but zero anchors
    // (someone deleted every paid pot, leaving only free pots / protection), wipe
    // the whole cart — otherwise you could check out a cart of only €0 gifts.
    // Returns true when it wiped so the caller skips redundant free-gift syncing.
    async #enforceAnchorIntegrity() {
      const cart = this.#cart;
      if (!cart?.items || cart.items.length === 0) return false;
      if (this.#anchorItems(cart).length > 0) return false;
      try {
        const r = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        });
        this.#cart = r.ok ? await r.json() : await this.#fetchCart();
      } catch (_) {
        this.#cart = await this.#fetchCart();
      }
      const stillGifted = (this.#cart?.items || []).some((it) =>
        (it.final_price === 0 || it.price === 0) && it.properties && it.properties.Offre != null);
      if (stillGifted && window.__hgReconcileFreeGift) {
        try {
          const guarded = await window.__hgReconcileFreeGift();
          if (guarded) this.#cart = guarded;
        } catch (_) {}
      }
      return true;
    }

    async #addFreePots(variantId, quantity) {
      this.#internalAddCount++;
      try {
        // Mirror the buybox: carry _ref_cents so the €0 line can be struck at the
        // pot's real value. Sourced from the buybox CTA strike when present.
        let ref = 0;
        const strike = document.querySelector('[data-wgl-buybox] [data-ref-cents]');
        if (strike) ref = parseInt(strike.getAttribute('data-ref-cents') || '0', 10) || 0;
        // Same naming as the buybox: the line is named after the pack the customer
        // picked, so a pot added here and a pot added from the buybox read identically
        // in the drawer, cart and order. No emoji (CLAUDE.md section 8).
        const activePack = document.querySelector('[data-wgl-buybox] .bundle.active');
        const offerName = activePack
          ? [activePack.dataset.wglLabel, activePack.dataset.wglFreeLabel].filter(Boolean).join(' ').trim()
          : '';
        const properties = { Offre: offerName || 'Offert' };
        if (ref) properties._ref_cents = String(ref);
        const r = await fetch(this.config.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity, properties }] }),
        });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return await r.json();
      } finally {
        this.#internalAddCount--;
      }
    }

    // Reconcile the €0 free-pot line to the paid pot count. Add / change / remove
    // so editing quantity inside the drawer moves the free pots automatically.
    async #syncFreeGift() {
      const ladder = this.#giftLadder();
      if (!ladder) return;
      const cart = this.#cart;
      if (!cart?.items) return;
      const freeId = ladder.freeVariantId;
      const mainId = ladder.mainProductId;

      // Paid pots = anchors that aren't the free pot itself. When the buybox exposes its
      // main product id, count ONLY that product's pots — a distinct paid cross-sell (the
      // Magnésium upsell) would otherwise inflate the tier and grant phantom free Boosters.
      const paid = this.#anchorItems(cart)
        .filter((it) => it.variant_id !== freeId)
        .filter((it) => !mainId || it.product_id === mainId)
        .reduce((sum, it) => sum + it.quantity, 0);

      // Step-down: highest tier whose paid threshold is met, capped at the top pack.
      let target = 0;
      ladder.tiers.forEach((t) => { if (paid >= t.paid) target = t.free; });

      // Never match on the label text: the buybox names this line after the selected
      // pack ("2 pots achetés + 1 offert"), so a hardcoded string silently stops
      // matching the moment that copy changes. Variant id is the real identity; the
      // zero-price fallback catches lines added before the id was stamped.
      const giftLines = cart.items.filter((it) =>
        it.variant_id === freeId ||
        (it.properties && it.properties.Offre != null && (it.final_price === 0 || it.price === 0)));
      const current = giftLines.reduce((sum, it) => sum + it.quantity, 0);
      if (target === current) return;

      if (current > target) {
        let extra = current - target;
        for (let i = giftLines.length - 1; i >= 0 && extra > 0; i--) {
          const line = giftLines[i];
          const cut = Math.min(extra, line.quantity);
          extra -= cut;
          this.#cart = await this.#changeLine(line.key, line.quantity - cut);
        }
      } else if (giftLines[0]) {
        this.#cart = await this.#changeLine(giftLines[0].key, giftLines[0].quantity + (target - current));
      } else if (target > 0) {
        await this.#addFreePots(freeId, target);
        this.#cart = await this.#fetchCart();
      }
    }

    async #syncProtection() {
      if (!this.config.protectionVariantId) return;
      const nonProt = this.#nonProtectionItems(this.#cart);
      const protLine = this.#protectionLine(this.#cart);
      const want = this.config.protectionPref && nonProt.length > 0;
      // Errors propagate — callers that need rollback (handleProtectionToggle) catch;
      // callers that just want best-effort (refresh) wrap in their own try.
      if (want && !protLine) {
        await this.#addVariant(this.config.protectionVariantId, 1);
        this.#cart = await this.#fetchCart();
      } else if (want && protLine && protLine.quantity > 1) {
        this.#cart = await this.#changeLine(protLine.key, 1);
      } else if (!want && protLine) {
        this.#cart = await this.#changeLine(protLine.key, 0);
      }
    }

    #handleProtectionToggle = async () => {
      const previous = this.protectionToggle.getAttribute('aria-checked') === 'true';
      const nowChecked = !previous;
      // Optimistic: flip the visible state immediately so the tap feels instant.
      this.config.protectionPref = nowChecked;
      try { localStorage.setItem('hg-protection', nowChecked ? 'on' : 'off'); } catch (_) {}
      this.protectionToggle.setAttribute('aria-checked', String(nowChecked));
      try {
        await this.#syncProtection();
        this.#render();
        this.#emitCartEvents(this.#cart);
        this.#hideError();
      } catch (error) {
        // Roll back the optimistic flip — cart API rejected the change.
        console.error('hg-cart protection toggle error:', error);
        this.config.protectionPref = previous;
        try { localStorage.setItem('hg-protection', previous ? 'on' : 'off'); } catch (_) {}
        this.protectionToggle.setAttribute('aria-checked', String(previous));
        this.#showError(this.config.errProtection);
        // Re-sync from server: if addVariant committed before the failure threw,
        // syncProtection will now remove the orphan line (pref was rolled back).
        try { await this.refresh(); } catch (_) {}
      }
    };

    #handleSubUpgrade = async () => {
      if (!this.#cart || !this.subUpgradeBtn) return;
      const oneTimeLines = (this.#cart.items || []).filter((it) => {
        if (this.config.protectionVariantId && it.variant_id === this.config.protectionVariantId) return false;
        if (!(it.final_price > 0)) return false;
        return !it.selling_plan_allocation;
      });
      if (!oneTimeLines.length) return;

      this.subUpgradeBtn.disabled = true;
      const originalText = this.subUpgradeLabel ? this.subUpgradeLabel.textContent : 'Activer et économiser';
      if (this.subUpgradeLabel) this.subUpgradeLabel.textContent = 'Activation…';

      try {
        await this.#hydrateCompareAt(this.#cart);

        for (const line of oneTimeLines) {
          const handle = line.handle;
          if (!handle) continue;
          let planId = this._sellingPlanByVariant[line.variant_id];
          if (!planId) {
            try {
              const r = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
              if (!r.ok) continue;
              const p = await r.json();
              const variant = (p.variants || []).find((v) => v.id === line.variant_id);
              const allocation = variant?.selling_plan_allocations?.[0];
              planId = allocation?.selling_plan_id;
              if (planId) this._sellingPlanByVariant[line.variant_id] = planId;
            } catch (_) { /* network */ }
          }
          if (!planId) continue;
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: planId }),
          });
        }

        await this.refresh();
        this.#hideError();
        if (this.subUpgradeLabel) this.subUpgradeLabel.textContent = 'Activé ✓';
        clearTimeout(this._subUpgradeResetTimer);
        this._subUpgradeResetTimer = setTimeout(() => {
          if (this.subUpgradeLabel) this.subUpgradeLabel.textContent = originalText;
        }, 1800);
      } catch (error) {
        console.error('hg-cart sub upgrade error:', error);
        if (this.subUpgradeLabel) this.subUpgradeLabel.textContent = originalText;
        this.#showError(this.config.errSubscription);
      } finally {
        this.subUpgradeBtn.disabled = false;
      }
    };

    #handleUpsellAdd = async () => {
      if (!this.config.upsellVariantId) return;
      this.upsellAdd.disabled = true;
      const label = this.upsellAdd.querySelector('[data-hg-upsell-cta-label]');
      const originalText = this.config.upsellCta || 'Ajouter au panier';
      try {
        await this.#addVariant(this.config.upsellVariantId, 1);
        await this.refresh();
        this.#hideError();
        if (label) label.textContent = 'Ajouté ✓';
        clearTimeout(this._upsellResetTimer);
        this._upsellResetTimer = setTimeout(() => {
          if (label) label.textContent = originalText;
        }, 1800);
      } catch (error) {
        console.error('hg-cart upsell add error:', error);
        this.#showError(this.config.errUpsell);
      } finally {
        this.upsellAdd.disabled = false;
      }
    };

    #handleQtyChange = async (key, qty) => {
      // Dedupe rapid clicks on the same line — the first POST removes (or updates)
      // the line, and a second POST with the same key hits Shopify after the line is
      // already gone, getting back a 422 Cart Error. Without this guard, the second
      // click would surface a misleading error toast even though the first remove
      // actually succeeded.
      if (this.#lineBusy.has(key)) return;
      this.#lineBusy.add(key);
      const li = this.itemsEl?.querySelector(`.hg-cart__item[data-key="${CSS.escape(key)}"]`);
      if (li) li.setAttribute('aria-busy', 'true');
      try {
        const next = Math.max(0, parseInt(qty, 10) || 0);
        const result = await this.#changeLine(key, next);
        if (result) this.#cart = result;
        // Editing the paid qty must move the free pots (spec §5c) and, at 0 paid, wipe
        // the cart — so run the same guard + free-gift sync as refresh() before render.
        try {
          const wiped = await this.#enforceAnchorIntegrity();
          if (!wiped) {
            await this.#syncFreeGift();
            await this.#syncSubscriptionPlan();
          }
        } catch (e) { console.error('hg-cart free-gift sync error:', e); }
        try { await this.#syncProtection(); } catch (e) { console.error('hg-cart protection sync error:', e); }
        this.#render();
        this.#emitCartEvents(this.#cart);
        this.#hideError();
      } catch (error) {
        console.error('hg-cart qty change error:', error);
        this.#showError(this.config.errQty);
        try { await this.refresh(); } catch (_) {}
      } finally {
        this.#lineBusy.delete(key);
        // Note: the LI may have been replaced by the render above; reading the
        // post-render node is intentional, in case the row still exists.
        const liAfter = this.itemsEl?.querySelector(`.hg-cart__item[data-key="${CSS.escape(key)}"]`);
        if (liAfter) liAfter.removeAttribute('aria-busy');
      }
    };

    // Fire the Shopify-standard cart events plus our internal one so the rest of the
    // theme (header count, sticky ATC, apps) can react without coupling to hg-cart.
    #emitCartEvents(cart) {
      const detail = { cart: cart || this.#cart, source: 'hg-cart-drawer' };
      // Flag is read by the cart:updated/cart:refresh listener below so our own
      // emit doesn't loop back into another refresh.
      this._emittingCartEvents = true;
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
      } finally {
        this._emittingCartEvents = false;
      }
    }

    #showError(msg) {
      if (!this.errorEl) return;
      const text = msg || this.config?.errGeneric || '';
      // Unhide BEFORE mutating textContent so the live region is in the
      // accessibility tree when the mutation lands — otherwise assistive tech
      // can miss the announcement (region was inert at the moment of change).
      this.errorEl.hidden = false;
      this.errorEl.textContent = text;
      clearTimeout(this._errorTimer);
      this._errorTimer = setTimeout(() => this.#hideError(), 4000);
    }

    #hideError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    #formatMoney(cents) {
      const amount = (Number(cents) || 0) / 100;
      const fixed = amount.toFixed(2);
      const noDec = Math.round(amount).toString();
      return (this.config.moneyFormat || (('{' + '{amount_with_comma_separator' + '}' + '}') + ' €'))
        .replace(/\{\{\s*amount\s*\}\}/g, fixed)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
    }

    #escape(str) {
      return String(str ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    }

    // Brand spelling: Shopify product is "Honey Gummies™" (two words) but the brand is HoneyGummies™ (one word).
    #brandify(str) {
      // Normalise brand spelling and strip a "free gift" title prefix so the free
      // pot shows the SAME clean name as the paid pot (not "GRATUIT: …").
      return String(str ?? '')
        .replace(/Honey\s+Gummies/g, 'HoneyGummies')
        .replace(/^\s*(?:GRATUIT|CADEAU|OFFERT|FREE\s*GIFT)\s*:\s*/i, '');
    }

    #render() {
      try { this.#renderImpl(); }
      catch (error) { console.error('hg-cart render error:', error); }
    }

    #renderImpl() {
      const cart = this.#cart;
      if (!cart) return;

      const visible = this.#nonProtectionItems(cart);
      const visibleCount = visible.reduce((sum, it) => sum + it.quantity, 0);
      if (this.countEl) this.countEl.textContent = visibleCount;
      if (this.countWrapEl) this.countWrapEl.hidden = visibleCount === 0;

      const isEmpty = visible.length === 0;
      if (this.dialog) this.dialog.classList.toggle('hg-cart--empty', isEmpty);

      if (isEmpty) {
        if (this.emptyEl) this.emptyEl.hidden = false;
        if (this.itemsEl) this.itemsEl.innerHTML = '';
        if (this.protectionEl) this.protectionEl.hidden = true;
        if (this.upsellEl) this.upsellEl.hidden = true;
        if (this.subUpgradeEl) this.subUpgradeEl.hidden = true;
        return;
      }

      if (this.emptyEl) this.emptyEl.hidden = true;
      if (this.protectionEl) this.protectionEl.hidden = !this.config.protectionVariantId;

      // Subscription savings — computed per line from each variant's ACTUAL Kaching
      // selling-plan allocation (one-time unit price minus subscription unit price), so the
      // pill always matches what the customer is charged even when products carry different
      // plans (e.g. the Magnésium upsell at -20% vs the main pot). #hydrateCompareAt is
      // awaited before #render, so _subPriceMap is populated here; lines whose plan data
      // has not loaded fall back to the flat per-jar estimate (section setting savings_per_jar).
      const savingsPerJar = parseFloat(this.dataset.savingsPerJar) || 10;
      // A one-time PAID pot is upgradable to subscription. Free (€0) gift lines
      // have no selling plan either, but they can't be subscribed — exclude them
      // so the "Passe à l'abonnement" upsell hides once the paid pots are all subs.
      const oneTimeLines = visible.filter((it) => !it.selling_plan_allocation && it.final_price > 0);
      const oneTimeQty = oneTimeLines.reduce((sum, it) => sum + it.quantity, 0);
      const subSavings = oneTimeLines.reduce((sum, it) => {
        const subUnit = this._subPriceMap[it.variant_id];
        const perUnit = (typeof subUnit === 'number')
          ? Math.max(0, it.final_price - subUnit) // exact: one-time unit price minus sub unit price
          : savingsPerJar * 100;                  // fallback until this variant's plan data loads
        return sum + perUnit * it.quantity;
      }, 0); // cents

      const hasOneTime = oneTimeQty > 0;
      if (this.subUpgradeEl) this.subUpgradeEl.hidden = !hasOneTime;
      // Hide the upsell offer once its product is already in the cart (one-time OR subscribed) —
      // no point pitching a pot the customer just added.
      const upsellInCart = !!this.config.upsellVariantId
        && cart.items.some((it) => it.variant_id === this.config.upsellVariantId);
      if (this.upsellEl) this.upsellEl.hidden = !this.config.upsellVariantId || upsellInCart;

      // Query inside subUpgradeEl, not `this`: the pill gets moved into itemsEl and a
      // later all-subscription render's innerHTML wipe DETACHES it. this.querySelector
      // can't see detached nodes, so the stale "Économise 0,00 €" written during that
      // render would survive re-insertion. subUpgradeEl.querySelector works while detached.
      const savingsEl = this.subUpgradeEl ? this.subUpgradeEl.querySelector('[data-hg-sub-savings]') : null;
      if (savingsEl) {
        savingsEl.innerHTML = `Économise&nbsp;${this.#formatMoney(subSavings)}`;
      }

      if (this.itemsEl) {
        // Free (€0) lines render LAST — a bonus shown after the paid pots.
        const ordered = visible.slice().sort((a, b) => (a.final_price === 0 ? 1 : 0) - (b.final_price === 0 ? 1 : 0));

        this.itemsEl.innerHTML = ordered.map((it) => {
          const sp = it.selling_plan_allocation;
          const isFree = it.final_price === 0;
          const freqLabel = sp?.selling_plan?.name ?? '';
          const compareAt = this._compareAtMap[it.variant_id] || 0;
          const compare = compareAt > it.final_price
            ? compareAt
            : (it.original_price > it.final_price ? it.original_price : 0);
          // Value struck next to "Gratuit" — _ref_cents (per-pot value) first, then compare.
          const freeRef = isFree
            ? (parseInt(it.properties && it.properties._ref_cents, 10) || compare || it.original_price || 0)
            : 0;
          const variantTitle = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
          const img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/, '_160x$1$2') : '';
          const isOneTime = !sp && !isFree;
          return `
            <li class="hg-cart__item${isFree ? ' hg-cart__item--free' : ''}" data-key="${this.#escape(it.key)}" data-one-time="${isOneTime ? '1' : '0'}">
              ${freqLabel && !isFree ? `<div class="hg-cart__item-frequency">${this.#escape(freqLabel)}</div>` : ''}
              <div class="hg-cart__item-media">${img ? `<img src="${img}" alt="${this.#escape(this.#brandify(it.product_title))}">` : ''}</div>
              <div class="hg-cart__item-info">
                <h4 class="hg-cart__item-title">${this.#escape(this.#brandify(it.product_title))}</h4>
                ${variantTitle ? `<p class="hg-cart__item-variant">${this.#escape(variantTitle)}</p>` : ''}
                <div class="hg-cart__item-prices">
                  ${isFree
                    ? `<span class="hg-cart__item-price hg-cart__item-price--free">Gratuit</span>${freeRef ? ` <s class="hg-cart__item-compare">${this.#formatMoney(freeRef)}</s>` : ''}`
                    : `<span class="hg-cart__item-price">${this.#formatMoney(it.final_price)}</span>${compare ? ` <s class="hg-cart__item-compare">${this.#formatMoney(compare)}</s>` : ''}`}
                </div>
                ${isFree
                  ? `<div class="hg-cart__qty hg-cart__qty--locked" role="group" aria-label="Quantité offerte">
                  <button type="button" disabled tabindex="-1" aria-hidden="true">−</button>
                  <input type="number" value="${it.quantity}" readonly tabindex="-1" aria-label="Quantité offerte">
                  <button type="button" disabled tabindex="-1" aria-hidden="true">+</button>
                </div>`
                  : `<div class="hg-cart__qty" role="group" aria-label="Quantité">
                  <button type="button" data-qty-dec aria-label="Diminuer">−</button>
                  <input type="number" value="${it.quantity}" min="0" data-qty-input aria-label="Quantité">
                  <button type="button" data-qty-inc aria-label="Augmenter">+</button>
                </div>`}
              </div>
              ${isFree ? '' : `<button type="button" class="hg-cart__item-remove" data-remove aria-label="Retirer">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
                  <line x1="6" y1="6" x2="18" y2="18"/>
                  <line x1="18" y1="6" x2="6" y2="18"/>
                </svg>
              </button>`}
            </li>
          `;
        }).join('');
        this.#attachItemListeners();

        // Place subscription upsell directly after the first one-time line item.
        if (this.subUpgradeEl && hasOneTime) {
          const firstOneTime = this.itemsEl.querySelector('.hg-cart__item[data-one-time="1"]');
          if (firstOneTime) {
            firstOneTime.insertAdjacentElement('afterend', this.subUpgradeEl);
            this.subUpgradeEl.hidden = false;
          }
        }
      }

      // Totals
      if (this.totalEl) this.totalEl.textContent = this.#formatMoney(cart.total_price);
      const trueOriginal = (cart.items || []).reduce((sum, it) => {
        const compareAt = this._compareAtMap[it.variant_id] || 0;
        const base = compareAt > it.final_price ? compareAt : (it.original_price || it.final_price);
        return sum + (base * it.quantity);
      }, 0);
      if (trueOriginal > cart.total_price) {
        if (this.compareEl) {
          this.compareEl.textContent = this.#formatMoney(trueOriginal);
          this.compareEl.hidden = false;
        }
        const savedCents = trueOriginal - cart.total_price;
        if (this.savingsEl && savedCents > 0) {
          this.savingsEl.textContent = `${this.#formatMoney(savedCents)} ${this.config.savingsLabel}`;
          this.savingsEl.hidden = false;
        }
      } else {
        if (this.compareEl) this.compareEl.hidden = true;
        if (this.savingsEl) this.savingsEl.hidden = true;
      }

      // Shipping line + progress bar fill driven via --hg-ship-fill CSS variable.
      const threshold = this.config.freeShipThresholdCents || 0;
      const progressTotal = visible.reduce((sum, it) => sum + (it.final_line_price || 0), 0);
      const unlocked = threshold > 0 ? progressTotal >= threshold : true;
      const fillPct = threshold > 0 ? Math.min(100, Math.round((progressTotal / threshold) * 100)) : 100;
      const shipProgress = this.querySelector('[data-hg-ship-progress]');
      if (shipProgress) shipProgress.style.setProperty('--hg-ship-fill', `${fillPct}%`);
      if (this.shipMsg) {
        if (unlocked) {
          this.shipMsg.innerHTML = this.config.freeShipMsgOver;
        } else {
          const remaining = Math.max(0, threshold - progressTotal);
          this.shipMsg.innerHTML = this.config.freeShipMsgUnder.replace(/REMAINING_AMOUNT/g, this.#formatMoney(remaining));
        }
      }

      if (this.protectionEl && this.protectionToggle) {
        const prot = this.#protectionLine(cart);
        this.protectionToggle.setAttribute('aria-checked', prot ? 'true' : 'false');
      }
    }

    #attachItemListeners() {
      this.itemsEl.querySelectorAll('.hg-cart__item').forEach((li) => {
        const key = li.dataset.key;
        const input = li.querySelector('[data-qty-input]');
        li.querySelector('[data-qty-dec]')?.addEventListener('click', () => this.#handleQtyChange(key, parseInt(input.value, 10) - 1));
        li.querySelector('[data-qty-inc]')?.addEventListener('click', () => this.#handleQtyChange(key, parseInt(input.value, 10) + 1));
        input?.addEventListener('change', () => this.#handleQtyChange(key, input.value));
        li.querySelector('[data-remove]')?.addEventListener('click', () => this.#handleQtyChange(key, 0));
      });
    }
  }

  if (!customElements.get('hg-cart-drawer')) {
    customElements.define('hg-cart-drawer', HgCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-listicle"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var wrap = root.querySelector('.hgl');
    if (!wrap || wrap.dataset.hglReady === '1') return;
    wrap.dataset.hglReady = '1';

    if (wrap.dataset.hideChrome === 'true') {
      document.body.classList.add('hgl-chrome-off');
    }

    // Freshness stamp: roll the "last updated" date to the start of the
    // current quarter so the page never reads as stale. Opt-in per section.
    if (wrap.dataset.autoDate === 'true') {
      var el = wrap.querySelector('[data-hgl-updated]');
      if (el) {
        var now = new Date();
        var q = new Date(now.getFullYear(), Math.floor(now.getMonth() / 3) * 3, 1);
        var dd = String(q.getDate()).padStart(2, '0');
        var mm = String(q.getMonth() + 1).padStart(2, '0');
        el.textContent = el.textContent.replace(/\d{1,2}\/\d{1,2}\/\d{4}/, dd + '/' + mm + '/' + q.getFullYear());
      }
    }

    // Placeholder links (href="#") resolve to the offer page.
    wrap.addEventListener('click', function (evt) {
      var link = evt.target.closest('a');
      if (!link || !wrap.contains(link)) return;
      if (link.getAttribute('href') !== '#') return;
      evt.preventDefault();
      window.location.href = wrap.dataset.offerUrl || '/';
    });
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-questions"] && !Shopify.designMode) return;
  try {
    
/* ------------------------------------------------------------------
   Quiz haptics — a short tick on every tap inside the quiz.
   ------------------------------------------------------------------
   Two engines, picked at runtime:

   1. navigator.vibrate() — Android Chrome/Edge/Opera/Samsung. Needs a
      prior user interaction on the page; a quiz tap is one, so we are
      always inside a gesture here. Firefox dropped it in 129 and every
      desktop browser no-ops it, both of which are silent + harmless.

   2. iOS has no vibration API and Safari never shipped one. The one
      thing that DOES buzz is <input type="checkbox" switch>, which
      iOS 18+ gives native haptic feedback on toggle. So we keep one
      hidden switch and .click() it. It must stay RENDERED (opacity 0,
      not display:none) or WebKit skips the feedback, and it is built
      lazily on the first tap so it costs nothing on load.

   Wiring is delegated from `document` (once, guarded by window.HG) so
   any button the quiz grows later is covered for free and a
   shopify:section:load in the editor can't double-bind it.
   ------------------------------------------------------------------ */
(function () {
  var W = window;
  W.HG = W.HG || {};
  if (W.HG.haptics) { return; }

  /* Fallback only: the real value comes from the haptic_ms merchant setting.
     Not the ~12ms you'd use for a taptic engine. Most Android phones drive an
     ERM (rotating-mass) motor that needs real spin-up time, and the threshold
     varies by handset: measured on-device, 25ms was felt as nothing at all
     while 100ms was already harsh. 50ms sits in that gap. */
  var TICK_MS = 50;
  var MIN_GAP_MS = 30; /* collapse double-fires (pointerdown + synthetic click) */
  var lastAt = 0;
  var iosSwitch = null;

  var canVibrate = typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
  var canSwitch = !canVibrate && 'switch' in document.createElement('input');

  function switchEl() {
    if (iosSwitch) { return iosSwitch; }
    iosSwitch = document.createElement('input');
    iosSwitch.type = 'checkbox';
    iosSwitch.setAttribute('switch', '');
    iosSwitch.setAttribute('aria-hidden', 'true');
    iosSwitch.tabIndex = -1;
    iosSwitch.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none;';
    document.body.appendChild(iosSwitch);
    return iosSwitch;
  }

  /* Strength is a merchant setting, read from data-haptic-ms on the section
     root because Liquid does not render inside this block. 0 turns haptics
     off. iOS ignores it: the switch trick fires a fixed system tick. */
  function durationFor(el) {
    var root = el && el.closest ? el.closest('.qz-quiz') : null;
    var raw = root ? parseInt(root.getAttribute('data-haptic-ms'), 10) : NaN;
    return isNaN(raw) ? TICK_MS : raw;
  }

  function tick(ms) {
    var dur = typeof ms === 'number' ? ms : TICK_MS;
    if (dur <= 0) { return; }
    var now = Date.now();
    if (now - lastAt < MIN_GAP_MS) { return; }
    lastAt = now;
    try {
      if (canVibrate) { navigator.vibrate(dur); return; }
      if (canSwitch) { switchEl().click(); }
    } catch (e) { /* haptics are decoration — never break the quiz */ }
  }

  W.HG.haptics = { tick: tick, supported: canVibrate || canSwitch };

  /* pointerdown, not click: the buzz lands the instant the finger touches,
     matching the :active scale rather than trailing it by a frame. */
  document.addEventListener('pointerdown', function (evt) {
    var target = evt.target;
    if (!target || !target.closest) { return; }
    if (!target.closest('.qz-quiz button')) { return; }
    tick(durationFor(target));
  }, { passive: true });

  /* Keyboard activation never fires pointerdown — cover Enter/Space too. */
  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Enter' && evt.key !== ' ') { return; }
    if (evt.repeat) { return; }
    var target = document.activeElement;
    if (!target || !target.closest || !target.closest('.qz-quiz button')) { return; }
    tick(durationFor(target));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wg-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  // wg-cart-drawer v4 — bug fixes + cleaner UX
  class WgCartDrawer extends HTMLElement {
    #controller = null;
    #cart = null;
    #refreshing = null;
    #internalAddCount = 0;

    connectedCallback() {
      this.dialog = this.querySelector('dialog.wg-cart');
      this.itemsEl = this.querySelector('[data-wg-items]');
      this.emptyEl = this.querySelector('[data-wg-empty]');
      this.countEl = this.querySelector('[data-wg-count]');
      this.countWrapEl = this.querySelector('[data-wg-count-wrap]');
      this.totalEl = this.querySelector('[data-wg-total]');
      this.compareEl = this.querySelector('[data-wg-compare]');
      this.savingsEl = this.querySelector('[data-wg-savings]');
      this.shipMsg = this.querySelector('[data-wg-ship-msg]');
      this.shipFill = this.querySelector('[data-wg-ship-fill]');
      this.shipBar = this.querySelector('[data-wg-ship-bar]');
      this.bannerEl = this.querySelector('[data-wg-banner]');
      this.protectionEl = this.querySelector('[data-wg-protection]');
      this.protectionToggle = this.querySelector('[data-wg-protection-toggle]');
      this.upsellEl = this.querySelector('[data-wg-upsell]');
      this.upsellAdd = this.querySelector('[data-wg-upsell-add]');
      this.subUpgradeEl = this.querySelector('[data-wg-sub-upgrade]');
      this.subUpgradeBtn = this.querySelector('[data-wg-sub-upgrade-btn]');
      this.subUpgradeLabel = this.querySelector('[data-wg-sub-upgrade-label]');

      this.config = {
        moneyFormat: this.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}',
        cartAddUrl: this.dataset.cartAddUrl || '/cart/add',
        cartChangeUrl: this.dataset.cartChangeUrl || '/cart/change',
        cartUrl: this.dataset.cartUrl || '/cart',
        freeShipThresholdCents: parseInt(this.dataset.freeShipThresholdCents, 10) || 5000,
        freeShipMsgUnder: this.dataset.freeShipMsgUnder || 'Plus que REMAINING_AMOUNT pour la <strong>livraison offerte</strong>',
        freeShipMsgOver: this.dataset.freeShipMsgOver || 'Félicitations, vous avez débloqué la <strong>LIVRAISON OFFERTE</strong>',
        protectionVariantId: this.dataset.protectionVariantId ? parseInt(this.dataset.protectionVariantId, 10) : null,
        protectionPrice: parseInt(this.dataset.protectionPrice, 10) || 0,
        protectionTitle: this.dataset.protectionTitle || 'Shipping Protection',
        protectionDesc: this.dataset.protectionDesc || '',
        upsellVariantId: this.dataset.upsellVariantId ? parseInt(this.dataset.upsellVariantId, 10) : null,
        upsellImage: this.dataset.upsellImage || '',
        upsellTitle: this.dataset.upsellTitle || '',
        upsellDesc: this.dataset.upsellDesc || '',
        upsellPrice: this.dataset.upsellPrice || '',
        upsellCompareAt: this.dataset.upsellCompareAt || '',
        upsellPitch: this.dataset.upsellPitch || '',
        upsellCta: this.dataset.upsellCta || 'Ajouter au panier',
        discountBanner: this.dataset.discountBanner || '',
        savingsLabel: this.dataset.savingsLabel || 'économiser',
        trust1: this.getAttribute('data-trust-1') || '4.7 étoiles · 500 000+ avis',
        trust2: this.getAttribute('data-trust-2') || 'Pause ou résiliation à tout moment',
        trust3: this.getAttribute('data-trust-3') || 'Garantie 60 jours<br>satisfait ou remboursé',
        protectionPref: this.#readProtectionPref()
      };

      this.#attachListeners();
      this.#bindGlobalCartTriggers();
      this.#interceptCartFetch();
      // Defer renderStatic + initial cart fetch — the user hasn't opened the drawer yet.
      // Saves ~5-10ms of main-thread work on first paint.
      var idle = window.requestIdleCallback || function(cb){ return setTimeout(cb, 0); };
      idle(() => { this.#renderStatic(); this.refresh(); }, { timeout: 1200 });
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    #readProtectionPref() {
      try { return localStorage.getItem('wg-protection') !== 'off'; }
      catch (_) { return true; }
    }

    open = async () => {
      try {
        // Mark as loading BEFORE showing the modal so the empty-state markup
        // is suppressed during the brief refresh window. Without this the user
        // sees "your cart is empty" flash while /cart.js is in flight.
        if (this.dialog) this.dialog.classList.add('wg-cart--loading');
        if (this.dialog && !this.dialog.open) {
          this.#lockBodyScroll();
          try {
            this.dialog.showModal();
          } catch (showErr) {
            // showModal() failed (dialog in stale state, removed mid-call, etc.).
            // Roll back the scroll lock so the page isn't permanently stuck.
            this.#unlockBodyScroll();
            throw showErr;
          }
        }
        await this.refresh();
      } catch (error) {
        console.error('wg-cart open error:', error);
        if (this.dialog && !this.dialog.open) {
          try { this.dialog.showModal(); } catch (_) { this.#unlockBodyScroll(); }
        }
      } finally {
        if (this.dialog) this.dialog.classList.remove('wg-cart--loading');
      }
    };

    close = () => {
      try {
        if (this.dialog && this.dialog.open) this.dialog.close();
        this.#unlockBodyScroll();
      } catch (error) {
        console.error('wg-cart close error:', error);
      }
    };

    #lockBodyScroll() {
      // Idempotent: if already locked, don't re-capture scrollY (body is
      // already at fixed position 0, which would corrupt the restore target).
      if (this._scrollLocked) return;
      this._scrollLocked = true;
      this._scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this._scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    #unlockBodyScroll() {
      if (!this._scrollLocked) return;
      this._scrollLocked = false;
      const y = this._scrollY || 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      window.scrollTo(0, y);
    }

    async refresh(prefetchedCart) {
      if (this.#refreshing) return this.#refreshing;
      this.#refreshing = (async () => {
        try {
          // Skip the extra /cart.js fetch when the caller already has the latest cart
          // (e.g. came from /cart/change.js or /cart/add.js response).
          const cart = prefetchedCart || await this.#fetchCart();
          if (cart) this.#cart = cart;
          try { await this.#syncProtection(); } catch (e) { console.error('wg-cart sync protection error:', e); }
          // Fetch compare_at prices for any new products in the cart (cached)
          try { await this.#hydrateCompareAt(this.#cart); } catch (e) { console.error('wg-cart compare-at hydration error:', e); }
          this.#render();
        } catch (error) {
          console.error('wg-cart refresh error:', error);
        } finally {
          this.#refreshing = null;
        }
      })();
      return this.#refreshing;
    }

    // Variant ID -> compare_at_price (cents). Populated lazily.
    _compareAtMap = {};

    async #hydrateCompareAt(cart) {
      if (!cart?.items?.length) return;
      const handles = [];
      cart.items.forEach((it) => {
        if (!it.handle) return;
        if (this._compareAtMap[it.variant_id] !== undefined) return;
        if (!handles.includes(it.handle)) handles.push(it.handle);
      });
      if (!handles.length) return;
      await Promise.all(handles.map(async (h) => {
        try {
          const r = await fetch(`/products/${h}.js`, { headers: { Accept: 'application/json' } });
          if (!r.ok) return;
          const p = await r.json();
          (p.variants || []).forEach((v) => {
            this._compareAtMap[v.id] = v.compare_at_price || 0;
          });
        } catch (_) {}
      }));
    }

    #setText(selector, value) {
      const el = this.querySelector(selector);
      if (el) el.textContent = value || '';
    }

    #renderStatic() {
      if (this.config.protectionVariantId) {
        this.#setText('[data-wg-protection-title]', this.config.protectionTitle);
        this.#setText('[data-wg-protection-desc]', this.config.protectionDesc);
        this.#setText('[data-wg-protection-price]', this.#formatMoney(this.config.protectionPrice));
      }

      if (this.config.upsellVariantId) {
        const pitchEl = this.querySelector('[data-wg-upsell-pitch]');
        if (pitchEl) pitchEl.innerHTML = this.config.upsellPitch || '';
        const imgEl = this.querySelector('[data-wg-upsell-image]');
        if (imgEl) {
          imgEl.src = this.config.upsellImage;
          imgEl.alt = this.config.upsellTitle;
        }
        this.#setText('[data-wg-upsell-title]', this.config.upsellTitle);
        this.#setText('[data-wg-upsell-desc]', this.config.upsellDesc);
        this.#setText('[data-wg-upsell-price]', this.config.upsellPrice);
        this.#setText('[data-wg-upsell-cta-label]', this.config.upsellCta);
        const compare = this.querySelector('[data-wg-upsell-compare]');
        if (compare && this.config.upsellCompareAt) {
          compare.textContent = this.config.upsellCompareAt;
          compare.hidden = false;
        }
      }

      if (this.config.discountBanner && this.bannerEl) {
        this.bannerEl.textContent = this.config.discountBanner;
        this.bannerEl.hidden = false;
      }

      // Trust badges — always show (defaults applied in config init, so each is non-empty).
      // Use innerHTML so settings containing <br> for line breaks render correctly.
      ['trust-1', 'trust-2', 'trust-3'].forEach((sel, idx) => {
        const el = this.querySelector(`[data-wg-${sel}]`);
        if (el) el.innerHTML = this.config[`trust${idx + 1}`];
      });
    }

    #attachListeners() {
      this.querySelectorAll('[data-wg-close]').forEach((el) => {
        el.addEventListener('click', this.close);
      });

      // Backdrop click to close (dialog reports clicks on backdrop with target === dialog)
      this.dialog.addEventListener('click', (e) => {
        if (e.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        const inside = e.clientX >= rect.left && e.clientX <= rect.right &&
                       e.clientY >= rect.top  && e.clientY <= rect.bottom;
        if (!inside) this.close();
      });

      // ESC key handled natively by dialog; ensure body scroll unlocks on every close.
      this.dialog.addEventListener('close', () => this.#unlockBodyScroll());
      // Track open via observer because dialog.showModal doesn't fire an event
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });

      if (this.protectionToggle) {
        this.protectionToggle.addEventListener('click', this.#handleProtectionToggle);
      }

      if (this.upsellAdd) {
        this.upsellAdd.addEventListener('click', this.#handleUpsellAdd);
      }

      if (this.subUpgradeBtn) {
        this.subUpgradeBtn.addEventListener('click', this.#handleSubUpgrade);
      }

      document.addEventListener('wg-cart:open', this.open);
      document.addEventListener('wg-cart:refresh', () => this.refresh());
    }

    #bindGlobalCartTriggers() {
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest?.('[data-wg-cart-trigger]');
        if (trigger) {
          e.preventDefault();
          e.stopPropagation();
          this.open();
          return;
        }
        const cartLink = e.target.closest?.('a[href$="/cart"], a[href="/cart"]');
        if (cartLink && !cartLink.closest('wg-cart-drawer')) {
          const href = cartLink.getAttribute('href');
          if (href && !href.includes('/cart/')) {
            e.preventDefault();
            e.stopPropagation();
            this.open();
          }
        }
      }, true);
    }

    #interceptCartFetch() {
      if (window.__wgCartFetchPatched) {
        window.__wgCartDrawerInstance = this;
        return;
      }
      window.__wgCartFetchPatched = true;
      window.__wgCartDrawerInstance = this;
      const original = window.fetch;
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : (input?.url ?? '');
        const instance = window.__wgCartDrawerInstance;
        const isAdd = url.includes('/cart/add');
        const isInternal = instance ? instance._internalAdding() : false;
        // Detect requests that explicitly opt out (our own buybox sends
        // X-WG-Source: buybox so we don't open the drawer twice).
        let isWgSource = false;
        try {
          const headers = init && init.headers;
          if (headers) {
            if (typeof headers.get === 'function') {
              isWgSource = !!headers.get('X-WG-Source');
            } else if (Array.isArray(headers)) {
              isWgSource = headers.some(([k]) => String(k).toLowerCase() === 'x-wg-source');
            } else {
              isWgSource = Object.keys(headers).some(k => k.toLowerCase() === 'x-wg-source');
            }
          }
          if (!isWgSource && input && typeof input !== 'string' && input.headers && typeof input.headers.get === 'function') {
            isWgSource = !!input.headers.get('X-WG-Source');
          }
        } catch (_) { /* defensive: never let header inspection break fetch */ }

        const result = original.apply(this, arguments);
        if (isAdd && !isInternal && !isWgSource && instance) {
          result.then((res) => {
            if (res && res.ok) {
              queueMicrotask(() => instance.open());
            }
          }).catch(() => {});
        }
        return result;
      };
    }

    _internalAdding() { return this.#internalAddCount > 0; }

    async #fetchCart() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      try {
        const response = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          signal: this.#controller.signal
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return await response.json();
      } catch (error) {
        if (error.name === 'AbortError') return this.#cart;
        console.error('wg-cart fetch error:', error);
        return null;
      }
    }

    async #changeLine(key, qty) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    }

    async #addVariant(variantId, quantity = 1) {
      this.#internalAddCount++;
      try {
        const response = await fetch(this.config.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] })
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return await response.json();
      } finally {
        this.#internalAddCount--;
      }
    }

    #nonProtectionItems(cart) {
      if (!cart?.items) return [];
      return cart.items.filter((it) => !this.config.protectionVariantId || it.variant_id !== this.config.protectionVariantId);
    }

    #protectionLine(cart) {
      if (!cart?.items || !this.config.protectionVariantId) return null;
      return cart.items.find((it) => it.variant_id === this.config.protectionVariantId) ?? null;
    }

    async #syncProtection() {
      if (!this.config.protectionVariantId) return;
      const nonProt = this.#nonProtectionItems(this.#cart);
      const protLine = this.#protectionLine(this.#cart);
      const want = this.config.protectionPref && nonProt.length > 0;
      try {
        if (want && !protLine) {
          await this.#addVariant(this.config.protectionVariantId, 1);
          // /cart/add.js returns only the added line, not the full cart — refresh required.
          this.#cart = await this.#fetchCart();
        } else if (want && protLine && protLine.quantity > 1) {
          this.#cart = await this.#changeLine(protLine.key, 1);
        } else if (!want && protLine) {
          this.#cart = await this.#changeLine(protLine.key, 0);
        }
      } catch (error) {
        console.error('wg-cart protection sync error:', error);
      }
    }

    #handleProtectionToggle = async () => {
      try {
        const nowChecked = this.protectionToggle.getAttribute('aria-checked') !== 'true';
        this.config.protectionPref = nowChecked;
        try { localStorage.setItem('wg-protection', nowChecked ? 'on' : 'off'); } catch (_) {}
        this.protectionToggle.setAttribute('aria-checked', String(nowChecked));
        await this.#syncProtection();
        this.#render();
      } catch (error) {
        console.error('wg-cart protection toggle error:', error);
      }
    };

    // For each one-time line in the cart, look up the product's first selling plan and
    // call /cart/change.js to attach it. Converts the line to a subscription in-place.
    #handleSubUpgrade = async () => {
      if (!this.#cart || !this.subUpgradeBtn) return;
      const oneTimeLines = (this.#cart.items || []).filter((it) => {
        if (this.config.protectionVariantId && it.variant_id === this.config.protectionVariantId) return false;
        return !it.selling_plan_allocation;
      });
      if (!oneTimeLines.length) return;

      this.subUpgradeBtn.disabled = true;
      const originalText = this.subUpgradeLabel ? this.subUpgradeLabel.textContent : 'Activer et économiser';
      if (this.subUpgradeLabel) this.subUpgradeLabel.textContent = 'Activation…';

      try {
        // Pre-load product data for compare_at + selling_plan lookup
        await this.#hydrateCompareAt(this.#cart);

        for (const line of oneTimeLines) {
          const handle = line.handle;
          if (!handle) continue;
          let planId = this._sellingPlanByVariant?.[line.variant_id];
          if (!planId) {
            try {
              const r = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
              if (!r.ok) continue;
              const p = await r.json();
              const variant = (p.variants || []).find((v) => v.id === line.variant_id);
              const allocation = variant?.selling_plan_allocations?.[0];
              planId = allocation?.selling_plan_id;
              if (planId) {
                this._sellingPlanByVariant = this._sellingPlanByVariant || {};
                this._sellingPlanByVariant[line.variant_id] = planId;
              }
            } catch (_) {}
          }
          if (!planId) continue;
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: planId })
          });
        }

        await this.refresh();
        this.subUpgradeBtn.classList.add('is-done');
        if (this.subUpgradeLabel) this.subUpgradeLabel.textContent = 'Activé ✓';
        clearTimeout(this._subUpgradeResetTimer);
        this._subUpgradeResetTimer = setTimeout(() => {
          this.subUpgradeBtn.classList.remove('is-done');
          if (this.subUpgradeLabel) this.subUpgradeLabel.textContent = originalText;
        }, 1800);
      } catch (error) {
        console.error('wg-cart sub upgrade error:', error);
        if (this.subUpgradeLabel) this.subUpgradeLabel.textContent = originalText;
      } finally {
        this.subUpgradeBtn.disabled = false;
      }
    };

    #handleUpsellAdd = async () => {
      if (!this.config.upsellVariantId) return;
      this.upsellAdd.disabled = true;
      const label = this.upsellAdd.querySelector('[data-wg-upsell-cta-label]');
      const originalText = this.config.upsellCta || 'Ajouter au panier';
      try {
        await this.#addVariant(this.config.upsellVariantId, 1);
        // /cart/add.js returns the added line; refresh() still needs the full cart for rendering
        await this.refresh();
        this.upsellAdd.classList.add('is-added');
        if (label) label.textContent = 'Ajouté ✓';
        clearTimeout(this._upsellResetTimer);
        this._upsellResetTimer = setTimeout(() => {
          this.upsellAdd.classList.remove('is-added');
          if (label) label.textContent = originalText;
        }, 1800);
      } catch (error) {
        console.error('wg-cart upsell add error:', error);
      } finally {
        this.upsellAdd.disabled = false;
      }
    };

    #handleQtyChange = async (key, qty) => {
      try {
        const next = Math.max(0, parseInt(qty, 10) || 0);
        const result = await this.#changeLine(key, next);
        if (result) this.#cart = result;
        try { await this.#syncProtection(); } catch (e) { console.error('wg-cart sync error:', e); }
        this.#render();
      } catch (error) {
        console.error('wg-cart qty change error:', error);
        try { await this.refresh(); } catch (_) {}
      }
    };

    #formatMoney(cents) {
      const amount = (Number(cents) || 0) / 100;
      const fixed = amount.toFixed(2);
      const noDec = Math.round(amount).toString();
      return (this.config.moneyFormat || '€{{amount_with_comma_separator}}')
        .replace(/\{\{\s*amount\s*\}\}/g, fixed)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
    }

    #escape(str) {
      return String(str ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    }

    #render() {
      try { this.#renderImpl(); }
      catch (error) { console.error('wg-cart render error:', error); }
    }

    #renderImpl() {
      const cart = this.#cart;
      if (!cart) return;

      const visible = this.#nonProtectionItems(cart);
      const visibleCount = visible.reduce((sum, it) => sum + it.quantity, 0);
      if (this.countEl) this.countEl.textContent = visibleCount;
      if (this.countWrapEl) this.countWrapEl.hidden = visibleCount === 0;

      const isEmpty = visible.length === 0;
      if (this.dialog) this.dialog.classList.toggle('wg-cart--empty', isEmpty);

      if (isEmpty) {
        if (this.emptyEl) this.emptyEl.hidden = false;
        if (this.itemsEl) this.itemsEl.innerHTML = '';
        if (this.protectionEl) this.protectionEl.hidden = true;
        if (this.upsellEl) this.upsellEl.hidden = true;
        if (this.subUpgradeEl) this.subUpgradeEl.hidden = true;
        return;
      }

      if (this.emptyEl) this.emptyEl.hidden = true;
      if (this.protectionEl) this.protectionEl.hidden = !this.config.protectionVariantId;

      // Show "Subscribe & Save" upgrade card if any visible line is one-time (no selling plan)
      const hasOneTime = visible.some((it) => !it.selling_plan_allocation);
      if (this.subUpgradeEl) {
        this.subUpgradeEl.hidden = !hasOneTime;
        // Will be repositioned after items render — see below
      }
      if (this.upsellEl) {
        // Show upsell whenever a variant is configured. The "+ Add" button
        // bumps quantity so the user can stack multiple jars of the same product.
        this.upsellEl.hidden = !this.config.upsellVariantId;
      }

      if (this.itemsEl) {
        this.itemsEl.innerHTML = visible.map((it) => {
          const sp = it.selling_plan_allocation;
          const freqLabel = sp?.selling_plan?.name ?? '';
          // Compare-at: prefer variant.compare_at_price when available, else fall back to original_price
          const compareAt = this._compareAtMap[it.variant_id] || 0;
          const compare = compareAt > it.final_price
            ? compareAt
            : (it.original_price > it.final_price ? it.original_price : 0);
          const savingsPerUnit = compare > it.final_price ? (compare - it.final_price) : 0;
          const variantTitle = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
          const img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/, '_160x$1$2') : '';
          const isOneTime = !sp;
          return `
            <li class="wg-cart__item" data-key="${this.#escape(it.key)}" data-one-time="${isOneTime ? '1' : '0'}">
              ${freqLabel ? `<div class="wg-cart__item-frequency">Delivered ${this.#escape(freqLabel.toLowerCase())}</div>` : ''}
              <div class="wg-cart__item-media">${img ? `<img src="${img}" alt="${this.#escape(it.product_title)}">` : ''}</div>
              <div class="wg-cart__item-info">
                <h4 class="wg-cart__item-title">${this.#escape(it.product_title)}</h4>
                ${variantTitle ? `<p class="wg-cart__item-variant">${this.#escape(variantTitle)}</p>` : ''}
                <div class="wg-cart__item-prices">
                  <span class="wg-cart__item-price">${this.#formatMoney(it.final_price)}</span>
                  ${compare ? `<s class="wg-cart__item-compare">${this.#formatMoney(compare)}</s>` : ''}
                </div>
                <div class="wg-cart__qty">
                  <button type="button" data-qty-dec aria-label="Decrease">−</button>
                  <input type="number" value="${it.quantity}" min="0" data-qty-input aria-label="Quantity">
                  <button type="button" data-qty-inc aria-label="Increase">+</button>
                </div>
              </div>
              <div class="wg-cart__item-actions">
                <button type="button" class="wg-cart__item-remove" data-remove aria-label="Remove">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>
                </button>
              </div>
            </li>
          `;
        }).join('');
        this.#attachItemListeners();

        // Reposition the Subscribe & Save card right AFTER the first one-time line item.
        if (this.subUpgradeEl && hasOneTime) {
          const firstOneTime = this.itemsEl.querySelector('.wg-cart__item[data-one-time="1"]');
          if (firstOneTime) {
            firstOneTime.insertAdjacentElement('afterend', this.subUpgradeEl);
            this.subUpgradeEl.hidden = false;
          }
        } else if (this.subUpgradeEl && !hasOneTime) {
          // No one-time items — park it back in original position (hidden) so it can be re-shown later
          if (this.subUpgradeEl.parentElement !== this.querySelector('.wg-cart__body')) {
            this.querySelector('.wg-cart__body')?.insertBefore(this.subUpgradeEl, this.itemsEl.nextSibling);
          }
        }
      }

      // Totals — use compare_at when available for the strikethrough/savings %
      if (this.totalEl) this.totalEl.textContent = this.#formatMoney(cart.total_price);
      const trueOriginal = (cart.items || []).reduce((sum, it) => {
        const compareAt = this._compareAtMap[it.variant_id] || 0;
        const base = compareAt > it.final_price ? compareAt : (it.original_price || it.final_price);
        return sum + (base * it.quantity);
      }, 0);
      if (trueOriginal > cart.total_price) {
        if (this.compareEl) {
          this.compareEl.textContent = this.#formatMoney(trueOriginal);
          this.compareEl.hidden = false;
        }
        const savedCents = trueOriginal - cart.total_price;
        if (this.savingsEl && savedCents > 0) {
          this.savingsEl.textContent = `${this.#formatMoney(savedCents)} économisés`;
          this.savingsEl.hidden = false;
        }
      } else {
        if (this.compareEl) this.compareEl.hidden = true;
        if (this.savingsEl) this.savingsEl.hidden = true;
      }

      // Shipping bar — always unlocked when cart has items (per request)
      const threshold = this.config.freeShipThresholdCents || 5000;
      const progressTotal = visible.reduce((sum, it) => sum + (it.final_line_price || 0), 0);
      const alwaysFreeShip = true; // free shipping unlocked whenever there's a visible item
      const progressPct = alwaysFreeShip ? 100 : (threshold > 0 ? Math.min(100, Math.round((progressTotal / threshold) * 100)) : 0);

      // Order summary
      const summaryDiscountRow = this.querySelector('[data-wg-summary-discount-row]');
      const summaryDiscountEl = this.querySelector('[data-wg-summary-discount]');
      const summaryDiscountChips = this.querySelector('[data-wg-summary-discount-chips]');
      const summaryShippingEl = this.querySelector('[data-wg-summary-shipping]');

      // Real savings = compare_at savings (variant compare_at_price vs final_price)
      //              + line-level savings (selling plans, automatic discounts)
      //              + cart-level discount codes
      const compareAtSavings = (cart.items || []).reduce((sum, it) => {
        const compareAt = this._compareAtMap[it.variant_id] || 0;
        if (compareAt > it.final_price) {
          return sum + (compareAt - it.final_price) * it.quantity;
        }
        return sum;
      }, 0);
      const lineSavings = (cart.items || []).reduce((sum, it) => {
        const orig = it.original_line_price || (it.original_price * it.quantity) || 0;
        const fin  = it.final_line_price    || (it.final_price * it.quantity)    || 0;
        return sum + Math.max(0, orig - fin);
      }, 0);
      const totalSavings = compareAtSavings + lineSavings + (cart.total_discount || 0);

      if (totalSavings > 0 && summaryDiscountRow) {
        if (summaryDiscountEl) summaryDiscountEl.textContent = '-' + this.#formatMoney(totalSavings);
        const codes = (cart.cart_level_discount_applications || [])
          .map((d) => d.title || d.code)
          .concat((cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code))
          .filter((v, i, a) => v && a.indexOf(v) === i);
        if (summaryDiscountChips) {
          summaryDiscountChips.innerHTML = codes.length
            ? codes.map((c) => `<span class="wg-cart__discount-chip">${this.#escape(c)}</span>`).join('')
            : '';
        }
        summaryDiscountRow.hidden = false;
      } else if (summaryDiscountRow) {
        summaryDiscountRow.hidden = true;
      }

      if (summaryShippingEl) {
        summaryShippingEl.textContent = 'FREE';
        summaryShippingEl.classList.add('wg-cart__summary-value--free');
        summaryShippingEl.classList.remove('wg-cart__summary-value--muted');
      }

      if (this.shipFill) this.shipFill.style.width = `${progressPct}%`;
      if (this.shipMsg) {
        // Runtime migration: any legacy "Bravo !" or short-form variant of the
        // unlocked message gets swapped to the canonical celebratory copy.
        const canonical = 'Félicitations, vous avez débloqué la <strong>LIVRAISON OFFERTE</strong>';
        const legacyMsg = /Bravo\s*!\s*Tu as d.bloqu.|Bravo\s*!\s*Vous avez d.bloqu.|^<strong>Livraison offerte<\/strong> d.bloqu.e?$/i;
        let msg = this.config.freeShipMsgOver || canonical;
        if (legacyMsg.test(msg)) msg = canonical;
        this.shipMsg.innerHTML = msg;
        if (this.shipBar) this.shipBar.classList.add('is-unlocked');
      }

      if (this.protectionEl && this.protectionToggle) {
        const prot = this.#protectionLine(cart);
        this.protectionToggle.setAttribute('aria-checked', prot ? 'true' : 'false');
      }
    }

    #attachItemListeners() {
      this.itemsEl.querySelectorAll('.wg-cart__item').forEach((li) => {
        const key = li.dataset.key;
        const input = li.querySelector('[data-qty-input]');
        li.querySelector('[data-qty-dec]')?.addEventListener('click', () => this.#handleQtyChange(key, parseInt(input.value, 10) - 1));
        li.querySelector('[data-qty-inc]')?.addEventListener('click', () => this.#handleQtyChange(key, parseInt(input.value, 10) + 1));
        input?.addEventListener('change', () => this.#handleQtyChange(key, input.value));
        li.querySelector('[data-remove]')?.addEventListener('click', () => this.#handleQtyChange(key, 0));
      });
    }
  }

  if (!customElements.get('wg-cart-drawer')) {
    customElements.define('wg-cart-drawer', WgCartDrawer);
  }

  } catch(e) { console.error(e); }
})();
})();
